import axios from 'axios';

export const fetchUnverifiedVisits = () => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    let {token} = getState().auth;
    if (token) {
      headers["Authorization"] = `JWT ${token}`;
    }

    return axios.get("/api/verifications.json", {headers})
      .then(res => {
        let unverifiedData = []
        for(var i = 0; i < res.data.length; i++) {
          if (res.data[i].has_been_verified === null || res.data[i].has_been_verified === false) {
            unverifiedData.push(res.data[i])
          }
        }
        return dispatch({type: 'FETCH_UNVERIFIED_VISITS', unverifiedVisits: unverifiedData});
      }).catch(function (error) {
        if(error.response.status === 401 || error.response.status === 403) {
          dispatch({type: "AUTHENTICATION_ERROR", data: error.response.data});
        } else {
          console.log(`${error.response.status} Server Error!`);
        }
      })
  }
}


export const fetchSingleUnverifiedVisit = (id) => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    let {token} = getState().auth;
    if (token) {
      headers["Authorization"] = `JWT ${token}`;
    }

    return axios.get(`/api/verifications/${id}.json`, {headers})
      .then(res => {
        return dispatch({type: 'FETCH_SINGLE_UNVERIFIED_VISIT', sinlgeUnverifiedVisit: res.data});
      }).catch(function (error) {
        if(error.response.status === 401 || error.response.status === 403) {
          dispatch({type: "AUTHENTICATION_ERROR", data: error.response.data});
        } else {
          console.log(`${error.response.status} Server Error!`);
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/verification.js